import { Grid2X2, MoreVertical, Pencil, Trash2 } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

type UserActionsMenuProps = {
  onBoards?: () => void;
  showBoards?: boolean;
  onEdit: () => void;
  onRemove: () => void;
};

const UserActionsMenu = ({
  onBoards,
  showBoards = true,
  onEdit,
  onRemove,
}: UserActionsMenuProps) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon-sm"
          className="h-8 w-8"
        >
          <MoreVertical className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {showBoards && onBoards ? (
          <DropdownMenuItem onClick={onBoards}>
            <Grid2X2 className="mr-2 h-4 w-4" />
            Boards
          </DropdownMenuItem>
        ) : null}
        <DropdownMenuItem onClick={onEdit}>
          <Pencil className="mr-2 h-4 w-4" />
          Edit
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onRemove} variant="destructive">
          <Trash2 className="mr-2 h-4 w-4" />
          Remove
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default UserActionsMenu;
